<template>
  <section>
    <div class="top">
      <el-row>
        <el-col :span="24">
          特别说明：所有接口请求后，返回值的判断标准：先判断res.status==200代表和服务器交互成功，然后res.data.isSuccess==true代表业务请求处理成功
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="24">&nbsp;</el-col>
      </el-row>
      <el-row>
        <el-col :span="12" style="background-color: #c8c9cc; font-size: 10px"
          >请求参数: {{ request }}</el-col
        >
        <el-col :span="12" style="background-color: #c8c9cc; font-size: 10px"
          >返回参数：{{ response }}</el-col
        >
      </el-row>
    </div>

    <section class="content">
      <el-row>
        <el-col :span="24">&nbsp;</el-col>
      </el-row>
      <el-row>
        <el-col :span="2">
          <el-button
            type="primary"
            :disabled="loading"
            :loading="loading"
            @click="queryAllBannerList"
            >首页获取轮播图</el-button
          >
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="24">
          使用说明：<br />
          title：标题 <br />
          coverImage: 轮播图图片信息 <br />
          coverImage.destinationUrl：如果存在，当点击轮播图的时候跳转到destinationUrl
          <br />
          coverImage.url: 图片展示url<br />
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="24">&nbsp;</el-col>
      </el-row>
      <el-row>
        <el-col :span="4">
          <el-button
            type="primary"
            :disabled="loading"
            :loading="loading"
            @click="queryAllVenueList"
            >首页获取光启空间数据</el-button
          >
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="24">
          使用说明：<br />
          address: 地址， <br />
          capacity: 容纳人数 <br />
          contentImage：场馆详细介绍时的轮播图 <br />
          coverImage：场馆封面图 <br />
          description：场馆介绍 <br />
          startTime：开放时间起 <br />
          endTime：开放时间范围末 <br />
          isDisable： 是否停用 <br />
          longitude：经度 <br />
          latitude： 纬度 <br />
          logo：场馆logo <strong style="color: red">【首页logo使用】</strong
          ><br />
          logo.url: 图片展示url<br />
          manager： 联系人 <br />
          tel：联系电话 <br />
          name：场馆名称 <br />
          title：标题 <strong style="color: red">【首页使用】</strong><br />
          supportFacilities：场馆配备的设施（比如：WIFI，储物柜等） <br />
          supportSports：场馆可支持的运动类型 <br />
          typeId: 分类
          <strong style="color: red"
            >【光启空间卡片页使用，如“一层”，“二层”】</strong
          ><br />
          <br />
          点击更多时，跳转到光启空间卡片页
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="24">&nbsp;</el-col>
      </el-row>
      <el-row>
        <el-col :span="4">
          <el-button type="primary" :disabled="loading" :loading="loading" @click="getRemindActivity"
            >首页获取活动提醒数据</el-button
          >
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="24">
          使用说明：<br />
          根据活动开始时间正序查询我报名的活动第一页数据
          入参：page: 1, pageSize:1, startTime: 当前时间加30分钟（yyyy-MM-dd HH:mm:ss）,endTime: 当前时间加2天（yyyy-MM-dd HH:mm:ss）
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="24">&nbsp;</el-col>
      </el-row>
      <el-row>
        <el-col :span="4">
          <el-button
            type="primary"
            :disabled="loading"
            :loading="loading"
            @click="queryActivityListPage(null, null, null)"
            >首页获取光启超人气数据</el-button
          >
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="24">
          使用说明：<br />
          接口采用分页，默认只获取第一页数据，点击更多跳转到光启荟萃卡片页，然后获取分页数据<br />
          活动标题：title<br />
          开始时间：startTime<br />
          结束时间：endTime<br />
          活动地址：address<br />
          封面图：coverImage<br />
          发起人：promoterUser（包括姓名uRealName，头像logo ）<br />
          标签：tags（、分隔）<br />
          <br />
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="24">&nbsp;</el-col>
      </el-row>
      <el-row>
        <el-col :span="4">
          <strong>光启荟萃卡片页接口</strong>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="24">
          使用说明：<br />
          进入页面，首先：<el-button
            size="mini"
            type="primary"
            :loading="loading"
            :disabled="loading"
            @click="getActivityTypes"
            >获取活动分类字典</el-button
          >
          code: 对应活动typeId（比如：001001），
          value：对应活动类型的名称（比如：亲子类）
          <br /><br />
          然后：接口采用分页方式，默认只获取
          <el-button
            type="primary"
            size="mini"
            :disabled="loading"
            :loading="loading"
            @click="queryActivityListPage(null, null, '')"
            >第一页光启荟萃数据</el-button
          >，如果有时间选择，则请求参数中添加开始时间startTime，结束时间endTime,
          <el-button
            type="primary"
            size="mini"
            :disabled="loading"
            :loading="loading"
            @click="queryActivityListPage('2022-10-01', '2022-12-07', '')"
            >进行时间范围的过滤</el-button
          >

          点击更多,则将当前类别code（比如：亲子类001001），作为typeId传入参数，跳转到光启荟萃卡片页，
          <el-button
            type="primary"
            size="mini"
            :disabled="loading"
            :loading="loading"
            @click="queryActivityListPage(null, null, '001001')"
            >获取分页数据</el-button
          ><br />

          活动标题：title<br />
          开始时间：startTime<br />
          结束时间：endTime<br />
          活动地址：address<br />
          封面图：coverImage<br />
          发起人：promoterUser（包括姓名uRealName，头像logo ）<br />
          标签：tags（、分隔）<br />
          <br />
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="24">&nbsp;</el-col>
      </el-row>
      <el-row>
        <el-col :span="4">
          <el-button
            type="primary"
            :disabled="true"
            :loading="loading"
            @click="saveActivity"
            >发起活动，根据前端新增活动保存来</el-button
          >
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="24">
          使用说明：<br/>
            <code>
            let formData = new FormData(); <br/>
            formData.append("model", JSON.stringify(this.addForm)); <br/>
            let covers = this.coverImageList.filter((s) => s.status == "ready"); <br/>
            if (covers.length > 0) { <br/>
              formData.append("coverImage", covers[0].raw); <br/>
            } <br/>
            let contents = this.contentImageList.filter( <br/>
              (s) => s.status == "ready" <br/>
            ); <br/>
            if (contents.length > 0) { <br/>
              contents.forEach((element) => { <br/>
                formData.append("contentImages", element.raw); <br/>
              }); <br/>
            } <br/>
            saveActivity(formData).then(); <br/>

            其中model: {"title":"吃年猪饭","typeId":"001002","startTime":"2022-12-13 22:06:06","endTime":"2022-12-13 23:06:09","promoterId":1,"deadline":"2022-12-13 22:30:16","address":"浦江路1号","description":"吃年猪饭超级有趣","maxPeople":20,"tags":"年猪、土家族","hasMultiSessions":true,"integral":20,"venueId":"ba8d3419-521f-40a3-9d76-3f8a8c8a0777","multiSessions":[{"startTime":"2022-12-15 02:00","endTime":"2022-12-15 03:00"},{"startTime":"2022-12-15 04:00","endTime":"2022-12-15 05:00"}]} <br/>
            </code>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="24">&nbsp;</el-col>
      </el-row>
      <el-row>
        <el-col :span="4">
          <el-button
            type="primary"
            :disabled="loading"
            :loading="loading"
            @click="takePartActivity"
            >活动预约</el-button
          >
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="24">&nbsp;</el-col>
      </el-row>
      <el-row>
        <el-col :span="4">
          <el-button
            type="primary"
            :disabled="loading"
            :loading="loading"
            @click="giveUpActivity"
            >取消预约</el-button
          >
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="24">&nbsp;</el-col>
      </el-row>
      <el-row>
        <el-col :span="4">
          <el-button
            type="primary"
            :disabled="loading"
            :loading="loading"
            @click="signInActivity"
            >活动签到</el-button
          >
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="24">&nbsp;</el-col>
      </el-row>
      <el-row>
        <el-col :span="4">
          <el-button
            type="primary"
            :disabled="loading"
            :loading="loading"
            @click="getActivityDetail"
            >根据Id获取活动详情</el-button
          >
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="24">&nbsp;</el-col>
      </el-row>
      <el-row>
        <el-col :span="4">
          <el-button
            type="primary"
            :disabled="loading"
            :loading="loading"
            @click="getVenueDetail"
            >根据Id获取场馆详情</el-button
          >
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="24">&nbsp;</el-col>
      </el-row>
      <el-row>
        <el-col :span="4">
          <el-button
            type="primary"
            :disabled="loading"
            :loading="loading"
            @click="getMyPromoteActivity"
            >我的活动--我发起的</el-button
          >
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="24">
          使用说明：<br/>
          promoterId: 当前人的id,<br/>
          未开始的：startTime传当前时间（yyyy-MM-dd HH:mm:ss）、endTime: null; <br/>
          进行中的：startTime传当前时间（yyyy-MM-dd HH:mm:ss）、endTime: 传当前时间加1分钟（yyyy-MM-dd HH:mm:ss）; <br/>
          已结束的：startTime： null 、endTime: 传当前时间（yyyy-MM-dd HH:mm:ss）; <br/>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="24">&nbsp;</el-col>
      </el-row>
      <el-row>
        <el-col :span="4">
          <el-button
            type="primary"
            :disabled="loading"
            :loading="loading"
            @click="getMyTakeActivity"
            >我的活动--我参与的</el-button
          >
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="24">
          使用说明：<br/>
          <el-button
            type="primary"
            :disabled="loading"
            :loading="loading"
            @click="getMyTakeUnstartActivity">未开始的：</el-button>传当前时间（yyyy-MM-dd HH:mm:ss）、endTime: null; <br/><br/>
          <el-button
            type="primary"
            :disabled="loading"
            :loading="loading"
            @click="getMyTakeStartingActivity">进行中的：</el-button>startTime传当前时间（yyyy-MM-dd HH:mm:ss）、endTime: 传当前时间加1分钟（yyyy-MM-dd HH:mm:ss）; <br/><br/>
          <el-button
            type="primary"
            :disabled="loading"
            :loading="loading"
            @click="getMyTakeFinishActivity">已结束的：</el-button>startTime： null 、endTime: 传当前时间（yyyy-MM-dd HH:mm:ss）; <br/><br/>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="24">&nbsp;</el-col>
      </el-row>
      <el-row>
        <el-col :span="4">
          <el-button
            type="primary"
            :disabled="loading"
            :loading="loading"
            @click="getVenueActivity"
            >根据场馆Id获取预约的活动列表</el-button
          >
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="24"><br/>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="4">
          <el-button
            type="primary"
            :disabled="loading"
            :loading="loading"
            @click="getMallProductTypes"
            >获取商城商品类别</el-button
          >
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="24"><br/>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="4">
          <el-button
            type="primary"
            :disabled="loading"
            :loading="loading"
            @click="queryMallProductListPage"
            >获取商城商品</el-button
          >
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="24"><br/>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="4">
          <el-button
            type="primary"
            :disabled="loading"
            :loading="loading"
            @click="queryUserIntegralListPage"
            >获取积分记录</el-button
          >
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="24"><br/>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="4">
          <el-button
            type="primary"
            :disabled="loading"
            :loading="loading"
            @click="queryIntegralExchangeListPage"
            >获取积分兑换记录</el-button
          >
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="24"><br/>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="4">
          <el-button
            type="primary"
            :disabled="loading"
            :loading="loading"
            @click="saveIntegralExchange"
            >发起积分兑换记录</el-button
          >
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="24">
          <code>
            let formData = new FormData(); <br/>
            formData.append("model", JSON.stringify(this.addForm)); <br/>
            saveIntegralExchange(formData).then(); <br/>
            其中model:  {"userId":1,"integral":2000,"productId":"01b9c7ea-dc78-4b84-a346-e8d79e502e83"}<br/>
            </code>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="24"><br/>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="4">
          <el-button
            type="primary"
            :disabled="loading"
            :loading="loading"
            @click="saveRealVerify"
            >发起实名认证</el-button
          >
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="24">
          使用说明：<br/>
            <code>
            let formData = new FormData(); <br/>
            formData.append("model", JSON.stringify(this.addForm)); <br/>
            saveRealVerify(formData).then(); <br/>
            其中model: {"realName":"","identityNo":"","occupation":"","address":"","politicality":"","reason":""} <br/>
            </code>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="24">&nbsp;</el-col>
      </el-row>
      <el-row>
        <el-col :span="4">
          <el-button
            type="primary"
            :disabled="loading"
            :loading="loading"
            @click="saveFavorites"
            >添加收藏</el-button
          >
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="24">
          使用说明：<br/>
            <code>
            let formData = new FormData(); <br/>
            formData.append("model", JSON.stringify(this.addForm)); <br/>
            saveFavorites(formData).then(); <br/>
            其中model: {"objType":1,"objId":"7a1a118f-1e81-49ba-b39d-3434bcfbf46b"}<br/>
            objType枚举值：  <br/>
            export const FavoritesTypeEnum = {  <br/>
                Activity: 1, <br/>
                Venue: 2, <br/>
                Product: 3 <br/>
            }; <br/>
            </code>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="24">&nbsp;</el-col>
      </el-row>
      <el-row>
        <el-col :span="4">
          <el-button
            type="primary"
            :disabled="loading"
            :loading="loading"
            @click="removeFavorites"
            >取消收藏</el-button
          >
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="24">&nbsp;</el-col>
      </el-row>
      <el-row>
        <el-col :span="4">
          <el-button
            type="primary"
            :disabled="loading"
            :loading="loading"
            @click="saveUserNotes"
            >添加提醒</el-button
          >
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="24">
          使用说明：<br/>
            <code>
            let formData = new FormData(); <br/>
            formData.append("model", JSON.stringify(this.addForm)); <br/>
            saveFavorites(formData).then(); <br/>
            其中model: {"objType":1,"objId":"7a1a118f-1e81-49ba-b39d-3434bcfbf46b"}<br/>
            objType枚举值：  <br/>
            export const NotesTypeEnum = {  <br/>
                Activity: 1  <br/>
            };<br/>
            </code>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="24">&nbsp;</el-col>
      </el-row>
      <el-row>
        <el-col :span="4">
          <el-button
            type="primary"
            :disabled="loading"
            :loading="loading"
            @click="removeUserNotes"
            >取消提醒</el-button
          >
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="24">&nbsp;</el-col>
      </el-row>
    </section>
  </section>
</template>
<script>
import {
  queryAllBannerList,
  queryAllVenueList,
  queryMyAppointActivityPageList,
  queryActivityListPage,
  getActivityDetail,
  saveActivity,
  getVenueDetail,
  getChildDictionary,
  takePartActivity,
  giveUpActivity,
  signInActivity,
  queryUserIntegralListPage,
  queryIntegralExchangeListPage,
  saveIntegralExchange,
  queryMallProductListPage,
  saveRealVerify,
  saveFavorites,
  removeFavorites,
  saveUserNotes,
  removeUserNotes
} from "../api/api";
import moment from "moment"
export default {
  data() {
    return {
      loading: false,
      request: "",
      response: "",
    };
  },
  methods: {
    loadscroll() {},
    removeUserNotes() {
      this.loading = true;
      let request = {
        id: 40
      };
      this.request = JSON.stringify(request);
      removeUserNotes(request).then((res) => {
        console.log(res);
        this.response = JSON.stringify(res.data);
        if (res.data.isSuccess) {
          this.$notify({
            message: "获取成功，请F12查看Cosole输出，或Network",
            type: "success",
          });
        } else {
          this.$notify({
            message: "获取失败，请F12查看Cosole输出，或Network",
            type: "error",
          });
        }
        this.loading = false;
      });
    },
    saveUserNotes() {
      this.loading = true;
      let request = {
        objType: 1,
        objId:"7a1a118f-1e81-49ba-b39d-3434bcfbf46b"
      };
      let formData = new FormData();
      formData.append("model", JSON.stringify(request));
      this.request = "表单方式提交('model', "+JSON.stringify(request)+")";
      saveUserNotes(formData).then((res) => {
        console.log(res);
        this.response = JSON.stringify(res.data);
        if (res.data.isSuccess) {
          this.$notify({
            message: "获取成功，请F12查看Cosole输出，或Network",
            type: "success",
          });
        } else {
          this.$notify({
            message: "获取失败，请F12查看Cosole输出，或Network",
            type: "error",
          });
        }
        this.loading = false;
      });
    },
    removeFavorites(){
      this.loading = true;
      let request = {
        id: 40
      };
      this.request = JSON.stringify(request);
      removeFavorites(request).then((res) => {
        console.log(res);
        this.response = JSON.stringify(res.data);
        if (res.data.isSuccess) {
          this.$notify({
            message: "获取成功，请F12查看Cosole输出，或Network",
            type: "success",
          });
        } else {
          this.$notify({
            message: "获取失败，请F12查看Cosole输出，或Network",
            type: "error",
          });
        }
        this.loading = false;
      });
    },
    saveFavorites() {
      this.loading = true;
      let request = {
        objType: 1,
        objId:"7a1a118f-1e81-49ba-b39d-3434bcfbf46b"
      };
      let formData = new FormData();
      formData.append("model", JSON.stringify(request));
      this.request = "表单方式提交('model', "+JSON.stringify(request)+")";
      saveFavorites(formData).then((res) => {
        console.log(res);
        this.response = JSON.stringify(res.data);
        if (res.data.isSuccess) {
          this.$notify({
            message: "获取成功，请F12查看Cosole输出，或Network",
            type: "success",
          });
        } else {
          this.$notify({
            message: "获取失败，请F12查看Cosole输出，或Network",
            type: "error",
          });
        }
        this.loading = false;
      });
    },
    saveActivity() {
      this.loading = true;
      let request = {
        title: ""
      };
      let formData = new FormData();
      formData.append("model", JSON.stringify(request));
      formData.append("coverImage", "文件流数据");
      formData.append("contentImage", "文件流数据");
      this.request = "表单方式提交('model', "+JSON.stringify(request)+")";
      saveActivity(formData).then((res) => {
        console.log(res);
        this.response = JSON.stringify(res.data);
        if (res.data.isSuccess) {
          this.$notify({
            message: "获取成功，请F12查看Cosole输出，或Network",
            type: "success",
          });
        } else {
          this.$notify({
            message: "获取失败，请F12查看Cosole输出，或Network",
            type: "error",
          });
        }
        this.loading = false;
      });
    },
    saveRealVerify() {
      this.loading = true;
      let request = {
        realName: "",
        identityNo: "",
        occupation: "",
        address: "",
        politicality: "",
        reason: ""
      };
      let formData = new FormData();
      formData.append("model", JSON.stringify(request));
      this.request = "表单方式提交('model', "+JSON.stringify(request)+")";
      saveRealVerify(formData).then((res) => {
        console.log(res);
        this.response = JSON.stringify(res.data);
        if (res.data.isSuccess) {
          this.$notify({
            message: "获取成功，请F12查看Cosole输出，或Network",
            type: "success",
          });
        } else {
          this.$notify({
            message: "获取失败，请F12查看Cosole输出，或Network",
            type: "error",
          });
        }
        this.loading = false;
      });
    },
    saveIntegralExchange() {
      this.loading = true;
      let request = {
        userId: 1,
        integral: 2000,
        productId: '01b9c7ea-dc78-4b84-a346-e8d79e502e83'
      };
      let formData = new FormData();
      formData.append("model", JSON.stringify(request));
      this.request = "表单方式提交('model', "+JSON.stringify(request)+")";
      saveIntegralExchange(formData).then((res) => {
        console.log(res);
        this.response = JSON.stringify(res.data);
        if (res.data.isSuccess) {
          this.$notify({
            message: "获取成功，请F12查看Cosole输出，或Network",
            type: "success",
          });
        } else {
          this.$notify({
            message: "获取失败，请F12查看Cosole输出，或Network",
            type: "error",
          });
        }
        this.loading = false;
      });
    },
    queryIntegralExchangeListPage() {
      this.loading = true;
      let request = {
        page: 1,
        pageSize: 10,
        data: {
          userId: 1
        }
      };
      this.request = JSON.stringify(request);
      queryIntegralExchangeListPage(request).then((res) => {
        console.log(res);
        this.response = JSON.stringify(res.data);
        if (res.data.isSuccess) {
          this.$notify({
            message: "获取成功，请F12查看Cosole输出，或Network",
            type: "success",
          });
        } else {
          this.$notify({
            message: "获取失败，请F12查看Cosole输出，或Network",
            type: "error",
          });
        }
        this.loading = false;
      });
    },
    queryUserIntegralListPage() {
      this.loading = true;
      let request = {
        page: 1,
        pageSize: 10,
        data: {
          userId: 1
        }
      };
      this.request = JSON.stringify(request);
      queryUserIntegralListPage(request).then((res) => {
        console.log(res);
        this.response = JSON.stringify(res.data);
        if (res.data.isSuccess) {
          this.$notify({
            message: "获取成功，请F12查看Cosole输出，或Network",
            type: "success",
          });
        } else {
          this.$notify({
            message: "获取失败，请F12查看Cosole输出，或Network",
            type: "error",
          });
        }
        this.loading = false;
      });
    },
    getMallProductTypes() {
      let request = {
        code: "003",
      };
      this.loading = true;
      this.request = JSON.stringify(request);
      getChildDictionary(request).then((res) => {
        console.log(res);
        this.response = JSON.stringify(res.data);
        if (res.data.isSuccess) {
          this.$notify({
            message: "获取成功，请F12查看Cosole输出，或Network",
            type: "success",
          });
        } else {
          this.$notify({
            message: "获取失败，请F12查看Cosole输出，或Network",
            type: "error",
          });
        }
        this.loading = false;
      });
    },
    queryMallProductListPage() {
      this.loading = true;
      let request = {};
      this.request = JSON.stringify(request);
      queryMallProductListPage(request).then((res) => {
        console.log(res);
        this.response = JSON.stringify(res.data);
        if (res.data.isSuccess) {
          this.$notify({
            message: "获取成功，请F12查看Cosole输出，或Network",
            type: "success",
          });
        } else {
          this.$notify({
            message: "获取失败，请F12查看Cosole输出，或Network",
            type: "error",
          });
        }
        this.loading = false;
      });
    },
    queryAllBannerList() {
      this.loading = true;
      let request = {};
      this.request = JSON.stringify(request);
      queryAllBannerList(request).then((res) => {
        console.log(res);
        this.response = JSON.stringify(res.data);
        if (res.data.isSuccess) {
          this.$notify({
            message: "获取成功，请F12查看Cosole输出，或Network",
            type: "success",
          });
        } else {
          this.$notify({
            message: "获取失败，请F12查看Cosole输出，或Network",
            type: "error",
          });
        }
        this.loading = false;
      });
    },

    getVenueActivity() {
      let request = {
        page: 1,
        pageSize: 10,
        data: {
          venueId: "ba8d3419-521f-40a3-9d76-3f8a8c8a0777"
        },
      };
      this.loading = true;
      this.request = JSON.stringify(request);
      queryActivityListPage(request).then((res) => {
        console.log(res);
        this.response = JSON.stringify(res.data);
        if (res.data.isSuccess) {
          this.$notify({
            message: "获取成功，请F12查看Cosole输出，或Network",
            type: "success",
          });
        } else {
          this.$notify({
            message: "获取失败，请F12查看Cosole输出，或Network",
            type: "error",
          });
        }
        this.loading = false;
      });
    },

    getMyPromoteActivity() {
      let request = {
        page: 1,
        pageSize: 10,
        data: {
          promoterId: "1"
        },
      };
      this.loading = true;
      this.request = JSON.stringify(request);
      queryActivityListPage(request).then((res) => {
        console.log(res);
        this.response = JSON.stringify(res.data);
        if (res.data.isSuccess) {
          this.$notify({
            message: "获取成功，请F12查看Cosole输出，或Network",
            type: "success",
          });
        } else {
          this.$notify({
            message: "获取失败，请F12查看Cosole输出，或Network",
            type: "error",
          });
        }
        this.loading = false;
      });
    },

    getMyTakeActivity() {
      let request = {
        page: 1,
        pageSize: 10,
        data: {
        },
      };
      this.loading = true;
      this.request = JSON.stringify(request);
      queryMyAppointActivityPageList(request).then((res) => {
        console.log(res);
        this.response = JSON.stringify(res.data);
        if (res.data.isSuccess) {
          this.$notify({
            message: "获取成功，请F12查看Cosole输出，或Network",
            type: "success",
          });
        } else {
          this.$notify({
            message: "获取失败，请F12查看Cosole输出，或Network",
            type: "error",
          });
        }
        this.loading = false;
      });
    },

    getMyTakeUnstartActivity() {
      let request = {
        page: 1,
        pageSize: 10,
        data: {
          startTime: moment().format('YYYY-MM-DD HH:mm:ss'),
          endTime: null
        },
      };
      this.loading = true;
      this.request = JSON.stringify(request);
      queryMyAppointActivityPageList(request).then((res) => {
        console.log(res);
        this.response = JSON.stringify(res.data);
        if (res.data.isSuccess) {
          this.$notify({
            message: "获取成功，请F12查看Cosole输出，或Network",
            type: "success",
          });
        } else {
          this.$notify({
            message: "获取失败，请F12查看Cosole输出，或Network",
            type: "error",
          });
        }
        this.loading = false;
      });
    },

    getMyTakeStartingActivity() {
      let request = {
        page: 1,
        pageSize: 10,
        data: {
          startTime: moment().format('YYYY-MM-DD HH:mm:ss'),
          endTime: moment().add(1, "minute").format('YYYY-MM-DD HH:mm:ss')
        },
      };
      this.loading = true;
      this.request = JSON.stringify(request);
      queryMyAppointActivityPageList(request).then((res) => {
        console.log(res);
        this.response = JSON.stringify(res.data);
        if (res.data.isSuccess) {
          this.$notify({
            message: "获取成功，请F12查看Cosole输出，或Network",
            type: "success",
          });
        } else {
          this.$notify({
            message: "获取失败，请F12查看Cosole输出，或Network",
            type: "error",
          });
        }
        this.loading = false;
      });
    },

    getMyTakeFinishActivity() {
      let request = {
        page: 1,
        pageSize: 10,
        data: {
          startTime: null,
          endTime: moment().format('YYYY-MM-DD HH:mm:ss')
        },
      };
      this.loading = true;
      this.request = JSON.stringify(request);
      queryMyAppointActivityPageList(request).then((res) => {
        console.log(res);
        this.response = JSON.stringify(res.data);
        if (res.data.isSuccess) {
          this.$notify({
            message: "获取成功，请F12查看Cosole输出，或Network",
            type: "success",
          });
        } else {
          this.$notify({
            message: "获取失败，请F12查看Cosole输出，或Network",
            type: "error",
          });
        }
        this.loading = false;
      });
    },

    getActivityDetail() {
      this.loading = true;
      let request = {
        id: "0a4e0fcd-51d8-408e-9673-fc24df33647d"
      };
      this.request = JSON.stringify(request);
      getActivityDetail(request).then((res) => {
        console.log(res);
        this.response = JSON.stringify(res.data);
        if (res.data.isSuccess) {
          this.$notify({
            message: "获取成功，请F12查看Cosole输出，或Network",
            type: "success",
          });
        } else {
          this.$notify({
            message: "获取失败，请F12查看Cosole输出，或Network",
            type: "error",
          });
        }
        this.loading = false;
      });
    },

    getVenueDetail() {
      this.loading = true;
      let request = {
        id: "ba8d3419-521f-40a3-9d76-3f8a8c8a0777"
      };
      this.request = JSON.stringify(request);
      getVenueDetail(request).then((res) => {
        console.log(res);
        this.response = JSON.stringify(res.data);
        if (res.data.isSuccess) {
          this.$notify({
            message: "获取成功，请F12查看Cosole输出，或Network",
            type: "success",
          });
        } else {
          this.$notify({
            message: "获取失败，请F12查看Cosole输出，或Network",
            type: "error",
          });
        }
        this.loading = false;
      });
    },

    queryAllVenueList() {
      let request = {};
      this.loading = true;
      this.request = JSON.stringify(request);
      queryAllVenueList(request).then((res) => {
        console.log(res);
        this.response = JSON.stringify(res.data);
        if (res.data.isSuccess) {
          this.$notify({
            message: "获取成功，请F12查看Cosole输出，或Network",
            type: "success",
          });
        } else {
          this.$notify({
            message: "获取失败，请F12查看Cosole输出，或Network",
            type: "error",
          });
        }
        this.loading = false;
      });
    },

    getRemindActivity(){
      let request = {
        page: 1,
        pageSize: 1,
        data: {
          startTime: moment().add(30, "minute").format('YYYY-MM-DD HH:mm:ss'),
          endTime: moment().add(2, 'day').format('YYYY-MM-DD HH:mm:ss'),
        }
      };this.loading = true;
      this.request = JSON.stringify(request);
      queryMyAppointActivityPageList(request).then((res) => {
        console.log(res);
        this.response = JSON.stringify(res.data);
        if (res.data.isSuccess) {
          this.$notify({
            message: "获取成功，请F12查看Cosole输出，或Network",
            type: "success",
          });
        } else {
          this.$notify({
            message: "获取失败，请F12查看Cosole输出，或Network",
            type: "error",
          });
        }
        this.loading = false;
      });
    },

    queryActivityListPage(startTime, endTime, typeId) {
      let request = {
        page: 1,
        pageSize: 10,
        data: {
          startTime: startTime,
          endTime: endTime,
          typeId: typeId,
        },
      };
      this.loading = true;
      this.request = JSON.stringify(request);
      queryActivityListPage(request).then((res) => {
        console.log(res);
        this.response = JSON.stringify(res.data);
        if (res.data.isSuccess) {
          this.$notify({
            message: "获取成功，请F12查看Cosole输出，或Network",
            type: "success",
          });
        } else {
          this.$notify({
            message: "获取失败，请F12查看Cosole输出，或Network",
            type: "error",
          });
        }
        this.loading = false;
      });
    },

    getActivityTypes() {
      let request = {
        code: "001",
      };
      this.loading = true;
      this.request = JSON.stringify(request);
      getChildDictionary(request).then((res) => {
        console.log(res);
        this.response = JSON.stringify(res.data);
        if (res.data.isSuccess) {
          this.$notify({
            message: "获取成功，请F12查看Cosole输出，或Network",
            type: "success",
          });
        } else {
          this.$notify({
            message: "获取失败，请F12查看Cosole输出，或Network",
            type: "error",
          });
        }
        this.loading = false;
      });
    },

    takePartActivity() {
      let request = {
        activityId: "0a4e0fcd-51d8-408e-9673-fc24df33647d",
        sessionId: "4",
        userId: "1",
        userCount: "1",
        name: "覃双盼",
        tel: "15658860587",
      };
      this.loading = true;
      this.request = JSON.stringify(request);
      takePartActivity(request).then((res) => {
        console.log(res);
        this.response = JSON.stringify(res.data);
        if (res.data.isSuccess) {
          this.$notify({
            message: "获取成功，请F12查看Cosole输出，或Network",
            type: "success",
          });
        } else {
          this.$notify({
            message: "获取失败，请F12查看Cosole输出，或Network",
            type: "error",
          });
        }
        this.loading = false;
      });
    },

    giveUpActivity() {
      let request = {
        activityId: "0a4e0fcd-51d8-408e-9673-fc24df33647d",
        sessionId: "4",
        userId: "1",
      };
      this.loading = true;
      this.request = JSON.stringify(request);
      giveUpActivity(request).then((res) => {
        console.log(res);
        this.response = JSON.stringify(res.data);
        if (res.data.isSuccess) {
          this.$notify({
            message: "获取成功，请F12查看Cosole输出，或Network",
            type: "success",
          });
        } else {
          this.$notify({
            message: "获取失败，请F12查看Cosole输出，或Network",
            type: "error",
          });
        }
        this.loading = false;
      });
    },

    signInActivity() {
      let request = {
        activityId: "0a4e0fcd-51d8-408e-9673-fc24df33647d",
        sessionId: "4",
        userId: "1",
      };
      this.loading = true;
      this.request = JSON.stringify(request);
      signInActivity(request).then((res) => {
        console.log(res);
        this.response = JSON.stringify(res.data);
        if (res.data.isSuccess) {
          this.$notify({
            message: "获取成功，请F12查看Cosole输出，或Network",
            type: "success",
          });
        } else {
          this.$notify({
            message: "获取失败，请F12查看Cosole输出，或Network",
            type: "error",
          });
        }
        this.loading = false;
      });
    },
  },
};
</script>

<style scoped>
.top {
  position: fixed;
  right: 0px;
  bottom: 0px;
  height: 200px;
  width: calc(100vw - 210px);
  border-top: solid 1px lightgray;
  opacity: 19;
  z-index: 9999;
  background-color: orange;
}
.content {
  padding-bottom: 500px;
}
</style>